import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, X } from "lucide-react";
import { toast } from "sonner";
import { PORTAL_PIN, exitPortal } from "@/lib/mode";

// Lock button + PIN dialog to exit the self-guided Palm Portal (kiosk).
// Shared by the Portal intro and the hand-selection screen.
export default function PortalExit() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [pin, setPin] = useState("");

  const submit = () => {
    if (pin === PORTAL_PIN) {
      exitPortal();
      navigate("/choose", { replace: true });
    } else {
      toast.error("That's not the code");
      setPin("");
    }
  };

  return (
    <>
      <button
        onClick={() => setShow(true)}
        data-testid="portal-exit-button"
        className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-soma-surface2/70 text-soma-muted hover:text-soma-on"
        aria-label="Exit portal"
      >
        <Lock size={16} />
      </button>

      {show && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-5">
          <div className="w-full max-w-xs rounded-2xl border border-soma-border bg-soma-surface2 p-6" data-testid="portal-exit-dialog">
            <div className="mb-4 flex items-center justify-between">
              <p className="font-display text-xl text-soma-on">Exit the Portal</p>
              <button onClick={() => setShow(false)} className="text-soma-muted hover:text-soma-on"><X size={20} /></button>
            </div>
            <p className="mb-3 text-sm text-soma-on2">Enter the practitioner code.</p>
            <input
              type="password"
              inputMode="numeric"
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              autoFocus
              data-testid="portal-pin-input"
              className="w-full rounded-xl border border-soma-border bg-soma-surface px-4 py-3 text-center text-2xl tracking-[0.5em] text-soma-on outline-none focus:border-soma-brand"
              placeholder="••••"
            />
            <button
              onClick={submit}
              data-testid="portal-pin-submit"
              className="mt-4 w-full rounded-xl bg-soma-brand py-3 font-semibold text-soma-surface hover:opacity-90"
            >
              Exit
            </button>
          </div>
        </div>
      )}
    </>
  );
}
